import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { TasksService } from "@/services/v2/tasks";
import router from "@/router/v2";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'AbortModal',
  props: {
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleAbortModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const handleProceed = async () => {
  props.toggleAbortModal;
  // Note: removeActiveTaskFromIndexDB method may need to be implemented
  // await TasksService.removeActiveTaskFromIndexDB();
  router.push("/dashboard/sites");
};

return (_ctx: any,_cache: any) => {
  return (__props.showModal)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: __props.toggleAbortModal
      }, {
        header: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Warning! ")
        ])),
        main: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("p", null, "Proceeding will erase your progress on the current task!", -1)
        ])),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleProceed,
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Proceed "),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.toggleAbortModal && __props.toggleAbortModal(...args))),
            type: "button",
            class: "text-white bg-primary hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Cancel ")
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}
}

})